export default {
  'anchoring': require('./1_anchoring.json'),
  'the-sunk-cost-fallacy': require('./2_sunk-cost.json'),
  'the-availability-heuristic': require('./3_availability-heuristic.json'),
  'the-curse-of-knowledge': require('./4_curse-of-knowledge.json'),
  'confirmation-bias': require('./5_confirmation-bias.json'),
  'the-dunning-kruger-effect': require('./6_dunning-kruger.json'),
  'belief-bias': require('./7_belief-bias.json'),
  'self-serving-bias': require('./8_self-serving.json'),
  'the-backfire-effect': require('./9_backfire.json'),
  'the-barnum-effect': require('./10_barnum-effect.json'),
  'groupthink': require('./11_group-think.json'),
  'negativity-bias': require('./12_negatvity-bias.json'),
  'declinism': require('./13_declinism.json'),
  'the-framing-effect': require('./14_framing-effect.json'),
  'fundamental-attribution-error': require('./15_fundamental-attribution-error.json'),
  'the-halo-effect': require('./16_halo-effect.json'),
  'optimism-bias': require('./17_optimism-bias.json'),
  'pessimism-bias': require('./18_pessimism-bias.json'),
  'just-world-hypothesis': require('./19_just-world-bias.json'),
  'in-group-bias': require('./20_in-group-bias.json'),
  'the-placebo-effect': require('./21_placebo-bias.json'),
  'the-bystander-effect': require('./22_bystander-effect.json'),
  'reactance': require('./23_reactance.json'),
  'the-spotlight-effect': require('./24_spotlight-effect.json')
};



// WEBPACK FOOTER //
// ./resources/assets/js/src/biases/animations/index.js